import HandshakeIcon from '@mui/icons-material/Handshake';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type PartnershipTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * PartnershipTile is a pre-configured EntityTypeTile for the Partnership entity type.
 *
 * @example
 * ```tsx
 * <PartnershipTile
 *   selected={selectedType === 'partnership'}
 *   onClick={() => setSelectedType('partnership')}
 * />
 * ```
 */
const PartnershipTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<PartnershipTileProps>) => {
  return (
    <EntityTypeTile
      icon={<HandshakeIcon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Partnership"
      description="Two or more people or businesses run a business together and share profits and responsibilities."
      hint="Choose this if your business is formally run by two or more partners."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const PartnershipTile = withClarityTheme(PartnershipTileComponent);
